function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-282.934 -121.642) scale(1.99914)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 366.624,
  cy: 285.944,
  r: 225.096,
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "ru-ua_svg__a"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 366.624,
  cy: 285.944,
  r: 225.096
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ru-ua_svg__a)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.528 60.847h450.189v450.192H141.528",
  fill: "#f0f0f0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.528 210.911h450.189v150.064H141.528",
  fill: "#0083d6"
})));

function SvgRuUa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 900",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTAwIDkwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWw6c3BhY2U9InByZXNlcnZlIiBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjIiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODIuOTM0IC0xMjEuNjQyKSBzY2FsZSgxLjk5OTE0KSI+PGNpcmNsZSBjeD0iMzY2LjYyNCIgY3k9IjI4NS45NDQiIHI9IjIyNS4wOTYiIHN0eWxlPSJmaWxsOiNlYmViZWIiLz48Y2xpcFBhdGggaWQ9ImEiPjxjaXJjbGUgY3g9IjM2Ni42MjQiIGN5PSIyODUuOTQ0IiByPSIyMjUuMDk2Ii8+PC9jbGlwUGF0aD48ZyBjbGlwLXBhdGg9InVybCgjYSkiPjxwYXRoIGQ9Ik0wIDBoOTAwdjYwMEgwIiBzdHlsZT0iZmlsbDojZjBmMGYwO2ZpbGwtcnVsZTpub256ZXJvIiB0cmFuc2Zvcm09Im1hdHJpeCguNTAwMjEgMCAwIC43NTAzMiAxNDEuNTI4IDYwLjg0NykiLz48cGF0aCBkPSJNMCAyMDBoOTAwdjIwMEgwIiBzdHlsZT0iZmlsbDojMDA4M2Q2O2ZpbGwtcnVsZTpub256ZXJvIiB0cmFuc2Zvcm09Im1hdHJpeCguNTAwMjEgMCAwIC43NTAzMiAxNDEuNTI4IDYwLjg0NykiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgRuUa as ReactComponent };